export default "__VITE_ASSET__496e934e__"